import { RegisteredComponent } from "@builder.io/sdk-react";
import { DLD_FIELD, DLT_FIELD } from "../commonFields";

export const dropdownBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "Dropdown",
  image:
    "https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F83acca093fb24aaf94dee136e9a4b045",
  hideFromInsertMenu: true,
  inputs: [
    {
      name: "options",
      type: "list",
      required: true,
      subFields: [
        {
          name: "label",
          type: "string",
          defaultValue: "Label",
        },
        {
          name: "value",
          type: "string",
          localized: false,
          defaultValue: "Value",
        },
        {
          name: "disabled",
          type: "boolean",
          localized: false,
          defaultValue: false,
        },
      ],
      defaultValue: [
        {
          label: "Option 1",
          value: "option-1",
        },
        {
          label: "Option 2",
          value: "option-2",
        },
      ],
    },
    {
      name: "value",
      type: "object",
      helperText:
        "The selected value. If not set, the placeholder will be shown",
      localized: false,
      subFields: [
        {
          name: "label",
          type: "string",
          defaultValue: "Label",
        },
        {
          name: "value",
          type: "string",
          localized: false,
          defaultValue: "Value",
        },
        {
          name: "disabled",
          type: "boolean",
          localized: false,
          defaultValue: false,
        },
      ],
    },
    {
      name: "onChange",
      type: "javascript",
      localized: false,
    },
    {
      name: "onInitialize",
      type: "javascript",
      localized: false,
    },
    {
      name: "placeholder",
      type: "string",
      localized: true,
      required: false,
      defaultValue: {
        "@type": "@builder.io/core:LocalizedValue",
        Default: "Select an option",
      },
    },
    { ...DLT_FIELD, required: false },
    { ...DLD_FIELD, required: false },
  ],
  defaultStyles: {
    width: "100%",
  },
};
